import React from "react";
import { Offcanvas } from "react-bootstrap";
import "./EmporiumOffCanvas.scss";

interface EmporiumOffCanvasProps {
  show: boolean;
  handleClose: () => void;
}

const EmporiumOffCanvas: React.FC<EmporiumOffCanvasProps> = ({
  show,
  handleClose,
}) => {
  return (
    <Offcanvas show={show} onHide={handleClose} minWidth={500}>
      <Offcanvas.Header closeButton>
        <Offcanvas.Title className="ContactUsTitle"></Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="d-flex flex-column h-100">
          <div className="flex-grow-1 d-flex flex-column justify-content-center align-items-center">
            <div className="mb-5">
              <h2 className="sticker-text text-center">
                Music has been scientifically proven to relieve stress.
              </h2>
            </div>
            <div className="DescContainer text-center">
              <h6 className="mb-3">
                In person sessions are available in Nashville, Franklin, and New
                Orleans for beginners and professionals.
              </h6>
              <h6>
                We help musicians to learn, grow, excel, start recording, and
                get bookings. We offer online music lessons for those who do not
                live near our in person locations.
              </h6>
            </div>
          </div>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default EmporiumOffCanvas;
